import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'

import css from './index.scss'
import HTMLReactParser from 'html-react-parser'

import { Button, Modal } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { COMMUNICATION_CONTENT_VISIBLE, SET_COMMUNICATION_CONTENT } from '../../actions/types'

export const NotificationModal = () => {
const notification = useSelector(state => state.communication.notification)
const visible = useSelector(state => state.communication.visible)
const resolve = useSelector(state => state.communication.resolve)

const [canConfirm, setCanConfirm] = useState(false)

const bodyRef = useRef(null)

const dispatch = useDispatch()

const handleClose = () => {
  resolve(false)
  dispatch({type: COMMUNICATION_CONTENT_VISIBLE, payload: false })
}
const handleAfterClose = () => {
  dispatch({type: SET_COMMUNICATION_CONTENT, payload: {
    notification: undefined,
    resolve: () => {}
  }})
  setCanConfirm(false)
}


useEffect(() => {
    if (!bodyRef.current || !visible) return;
    const el = bodyRef.current;
    const handleScroll = () => {
      if (!canConfirm) {
        const scrolledToBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 24;
        if (scrolledToBottom) {
          setCanConfirm(true);
        }
      }
    };

    el.addEventListener('scroll', handleScroll);
    const resizeObserver = new ResizeObserver(() => {
      handleScroll();
    });
    resizeObserver.observe(el);
    handleScroll();
    return () => {
      el.removeEventListener('scroll', handleScroll);
      resizeObserver.disconnect();
    };
  }, [visible, canConfirm]);

  useEffect(() => {
    const el = bodyRef.current
    if(!visible && el){
    el.scrollTop = 0
    }
  }, [visible])
  

  return (
    <Modal
      title={<p className={css.title}>{notification?.name}</p>}
      width="60vw"
      zIndex={99999}
      footer={[
        <Button key="confirm" type="primary" onClick={() => resolve(true)} disabled={!canConfirm}>
          Confirmar
        </Button>,
      ]}
      style={{ minWidth: 500 }}
      bodyStyle={{ padding: 0 }}
      visible={visible}
      afterClose={handleAfterClose}
      onCancel={handleClose}
      getContainer={false}
    >
      <div className={css.body} ref={bodyRef}>
        {notification?.content && HTMLReactParser(notification.content)}
      </div>
    </Modal>
  )
}
